var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.url}},[_vm._v(" 此浏览器不支持该用户手册格式。请下载以查看： "),_c('a',{attrs:{"href":_vm.url}},[_vm._v("下载用户手册")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }